import * as Yup from 'yup';

const requestRecoveryPasswordSchema = Yup.object().shape({
  username: Yup.string().required('username required'),
  email: Yup.string().required('email required'),
});

export default requestRecoveryPasswordSchema;
